import { HTTP_API_V2 } from '../../http-common'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    enableRealtime ({ commit }, payload) {
      commit('clearError')
      const data = {
        devices: payload.devices,
        duration_minutes: payload.durationMinutes
      }
      return new Promise((resolve, reject) => {
        HTTP_API_V2.post('devices/realtime', data)
        .then(result => {
          resolve(result.data)
        })
        .catch(err => {
          commit('setError', err)
          reject(err)
        })
        .finally(() => {
          commit('setLoading', false)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/realtime/index.js